export const settingsService = {
  getSettings,
  setSettings
};

async function getSettings() {
  if (window.localStorage.engsettings) {
    let settings = JSON.parse(window.localStorage.engsettings);
    console.log("GOT SETTINGS FROM LOCALSTORAGE");

    return settings;
  } else {
    console.log("WAS MADE");
    window.localStorage.setItem("engsettings", JSON.stringify([true, true]));
  }
  return [true, true];
}

async function setSettings(newsetting) {
  if (window.localStorage.engsettings) {
    window.localStorage.setItem("engsettings", JSON.stringify(newsetting));
  } else {
    window.localStorage.setItem("engsettings", JSON.stringify([true, true]));
  }
}



// WEBPACK FOOTER //
// ./src/services/settingsService.js